import { IAIChatContext } from './interfaces';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { asyncControllerFunction } from '../../../services/asyncController/asyncControllerFunction';
import createPersonaChat from './api/createPersonaChat';
import getPersonaChat from './api/getPersonaChat';
import sendChatMessage from './api/sendChatMessage';
import getChatMessages from './api/getChatMessages';
import addPersonaPair from './api/AddPersonaPair';
import getPersonaPair from './api/GetPersonaPair';
import getPersonaSettings from './api/getPersonaSettings';
import queryRecentChatId from './api/queryRecentChatId';

const store = {
  messages: [],
};

export const getAIChatInitialData = async function (
  flowAPI: ControllerFlowAPI,
): Promise<IAIChatContext> {
  return {
    currentChatId: null,
    currentChatPair: null,
    chat: null,
    messages: [],
    personaSettings: null,
    setCurrentChatId(currentChatId: string) {
      flowAPI.controllerConfig.setProps({
        currentChatId,
      });
    },
    createPersonaChat: asyncControllerFunction(
      (personaId: string, firstMessage: string, configurationId?: string) => {
        return createPersonaChat(
          flowAPI,
          personaId,
          firstMessage,
          configurationId,
        );
      },
    ),
    requestPersonaChat: asyncControllerFunction((chatId: string) => {
      return getPersonaChat(flowAPI, chatId);
    }),
    async sendChatMessage(chatId: string, message: string, attachments: any) {
      void sendChatMessage(flowAPI, chatId, message, store);
    },
    requestChatMessages: asyncControllerFunction((chatId: string) => {
      return getChatMessages(flowAPI, chatId, store);
    }),
    async addPersonaPair(personaId: string, programId: string) {
      void addPersonaPair(flowAPI, personaId, programId);
    },
    getPersonaPair: (programId: string) => {
      void getPersonaPair(flowAPI, programId);
    },
    getPersonaSettings: asyncControllerFunction((personaId: string) => {
      return getPersonaSettings(flowAPI, personaId);
    }),
    queryRecentChatId: asyncControllerFunction((personaId: string) => {
      return queryRecentChatId(flowAPI, personaId);
    }),
  };
};
